import { portaledMenuPortalRootCss } from 'components/meetings/filter_modal/portaled_menu_styles'

const PORTAL_ID = 'scheduling-filter-menu-portal'

let cachedPortalRoot = null

/**
 * Returns a stable DOM node for scheduling filter-bar dropdown portals.
 *
 * @returns {HTMLElement | null} Portal root, or `null` when `document` is unavailable.
 */
export const getSchedulingFilterMenuPortalRoot = () => {
  if (typeof document === 'undefined') return null
  if (cachedPortalRoot?.isConnected) {
    cachedPortalRoot.dataset.reactAriaTopLayer = 'true'
    return cachedPortalRoot
  }

  cachedPortalRoot = document.createElement('div')
  cachedPortalRoot.setAttribute('id', PORTAL_ID)
  cachedPortalRoot.dataset.reactAriaTopLayer = 'true'
  cachedPortalRoot.className = portaledMenuPortalRootCss
  document.body.appendChild(cachedPortalRoot)

  return cachedPortalRoot
}

export const SCHEDULING_FILTER_MENU_PORTAL_ID = PORTAL_ID
